<template>

  <panel-navigation>
    
    <h1 class="text-lg font-semibold mb-3">Roadmap</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div class="dashboard-box stats-box w-full px-2 -mx-2">
      <v-card
        class="pa-2 h-full"
        tile
      >
        <div v-if="me" :class="'w-full mb-3 p-3'">
            <p class="mb-1 text-xs mb-2">
            
            At Accelerate Marketing, our users guide our development. Have a great feature suggestion? Add it! Or browser through the already added requests and vote what you'd like to see integrated within the app.
            
            <br /><br />
            
            When you add a feature request, please include a screenshot or video and be as detailed as possible in your description, so that we fully understand what your request is about. Feel free to browse our existing requests to get a grasp on how to best submit your own ideas.
            
            <br /><br />

            Suggested screenshot/video apps you can use:

            <br /><br />

            - <a href="https://zight.com/">https://zight.com/</a> (screenshot & video)<br />
            - <a href="https://www.screencast.com/">https://www.screencast.com/</a> (screenshot & video)<br />
            - <a href="https://www.loom.com/">https://www.loom.com/</a> (video only)<br />
            - <a href="https://www.veed.io/">https://www.veed.io/</a> (video only)

            </p>

            <!-- <div data-upvoty></div> -->
        </div>
      </v-card>
    </div>

  </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  metaInfo () {
    return {
      title: "Roadmap | " + this.$appName
    }
  },

  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile,
    })
  },

  components: {
    PanelNavigation
  },

  data () {
    return {
      
    }
  },

  methods: {
    
  },

  created() {
    return; 

    /*let self = this;
    tryUpvoty();

    function tryUpvoty() {
      console.log('try upvoty');
      if (!self.profile) {
        setTimeout(function() {
          tryUpvoty();
        }, 100);
        return;
      }

      upvoty.init('identify', {
          user: {
              id: self.profile.id,
              name: self.profile.first_name + " " + self.profile.last_name,
              email: self.profile.email,
          },
          baseUrl: 'accelerate-marketing.upvoty.com',
          publicKey: 'c9cae0d2de0535b6fa060a0119cef172',
      });

      setTimeout(function() {
        upvoty.init('render', {
          'ssoToken': null,
          'baseUrl': 'accelerate-marketing.upvoty.com'
        });
      }, 1000);
    }*/
  }
}
</script>